<template>
  <div>
    <form @submit.prevent="handleFormSubmit" class="form">
      <register-title class="form__title">Иной орган</register-title>
      <register-input
        v-model="form.full_name"
        componentID="series"
        inputType="text"
        label="Ф.И.О."
        inputPlaceholder="Ф.И.О."
        :isRequired="true"
        class="form__input"
      />
      <register-input
        v-model="form.birth_date"
        componentID="validity-date"
        inputType="date"
        label="Дата рождения"
        :maxDate="new Date()"
        :isRequired="true"
        class="form__input"
      />
      <register-input
        v-model="form.birth_place"
        componentID="series"
        inputType="text"
        label="Место рождения"
        inputPlaceholder="Место рождения"
        :isRequired="true"
        class="form__input"
      />
      <div class="select-container">
        <label class="label">Гражданство</label>
        <exp-select
          :options="registrationCountryList()"
          v-model="form.citizenship"
          title="Выберите страну"
        ></exp-select>
      </div>

      <register-input
        componentID="user-iin"
        label="ИИН/БИН"
        inputPlaceholder="ИИН/БИН"
        :isRequired="true"
        class="form__input"
        :inputMaxLength="12"
        v-model="form.iin"
      />
      <p
        class="login-form__error"
        v-if="form.iin.length == 12 && !validateIin(form.iin)"
      >
        Неверный ИИН
      </p>
      <div class="select-container">
        <label class="label">Тип документа</label>
        <exp-select
          :options="registrationDocumentTypesList"
          v-model="form.document_type"
          title="Выберите страну"
        ></exp-select>
      </div>
      <!--------------------------------------------------------   DOC SERIES   ----->
      <register-input
        v-model="form.document_serial"
        componentID="series"
        inputType="text"
        label="Серия документа "
        inputPlaceholder="Серия документа"
        :isRequired="false"
        class="form__input"
      />
      <div>
        <label class="label">
          Номер документа, удостоверяющего личность
          <span class="red">*</span>
        </label>
        <input
          type="text"
          class="input form__input wide"
          placeholder="Номер документа, удостоверяющего личность"
          required
          v-model="form.document_number"
          @keyup="formatDocNumber"
          @blur="formatDocNumber"
        />
      </div>

      <!--------------------------------------------------------   ISSUE DATE (START)    ----->
      <register-input
        v-model="form.document_issued_at"
        componentID="issue-date"
        inputType="date"
        :maxDate="new Date()"
        label="Дата выдачи"
        :isRequired="true"
        class="form__input"
      />
      <!--------------------------------------------------------   ISSUE DATE (END)   ----->
      <register-input
        v-model="form.document_valid_till"
        componentID="validity-date"
        inputType="date"
        label="Действителен до"
        :minDate="new Date()"
        :isRequired="true"
        class="form__input"
      />
      <register-input
        v-model="form.document_issuer"
        componentID="issuing-authority"
        inputType="text"
        label="Кем выдано"
        inputPlaceholder="Кем выдано"
        :isRequired="true"
        class="form__input"
      />
      <register-input
        v-model="form.power_document_name"
        componentID="operation_register_number"
        inputType="text"
        inputPlaceholder="Наименование документа на основании которых установлен состав высшего органа "
        label="Наименование документа на основании которых установлен состав высшего органа "
        :isRequired="false"
        class="form__input"
      />
      <register-input
        v-model="form.power_document_approved_at"
        inputType="date"
        componentID="validity-date"
        label="Дата последней редакции"
        :isRequired="false"
        class="form__input"
      />
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <button class="button form__button" @click="nextStep()">
            Назад
          </button>
        </div>
        <div class="col-xs-12 col-sm-6">
          <button class="button filled form__button">Сохранить</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import regFormMixin from "../form_mixin";
import QuestionInput from "../../register/QuestionInput";
import { FhsAxios } from "../../../services/axios";
export default {
  props: ["body_member_data"],
  name: "MainRegForm",
  data() {
    return {
      old_form: {},
      form: {
        full_name: "",
        citizenship: null,
        birth_date: null,
        birth_place: "",
        iin: "",
        document_type: null,
        document_serial: null,
        document_number: null,
        document_issued_at: null,
        document_valid_till: null,
        document_issuer: null,
        power_document_name: "",
        power_document_approved_at: ""
      },
      form_dates: [
        "birth_date",
        "document_issued_at",
        "document_valid_till",
        "power_document_approved_at"
        // "protocol_date",
      ]
    };
  },
  components: {},
  mixins: [regFormMixin],
  methods: {
    formatDocNumber() {
      // console.log(this.isKazDoc(this.form.document_type));
      if (this.isKazDoc(this.form.document_type)) {
        this.form.document_number = this.form.document_number.replace(
          /\D/g,
          ""
        );
        this.form.document_number = this.form.document_number.substr(0, 9);
      }
    },
    formatPhone() {
      let num = this.form.phone_number.replace(/\D/g, "").split(/(?=.)/);
      let i = num.length - 1;
      if (0 <= i) num.unshift("+");
      if (1 <= i) num.splice(2, 0, " ");
      if (4 <= i) num.splice(6, 0, " ");
      if (7 <= i) num.splice(10, 0, "-");
      if (9 <= i) num.splice(13, 0, "-");
      this.form.phone_number = num.join("");
    },
    isFormChanged() {
      return JSON.stringify(this.old_form) !== JSON.stringify(this.form);
    },
    fetchForm() {
      try {
        if (this.$route.params.member_id) {
          FhsAxios.get(
            `profile/user-control-member/${this.$route.params.member_id}`
          ).then(res => {
            if (res.data.status) {
              this.form = res.data.result;
              this.form_dates.forEach(date => {
                this.form[date] = this.dateFormat(this.form[date]);
              });
            }
          });

          // console.log(this.isKazDoc(this.form.document_type));
          this.old_form = JSON.parse(JSON.stringify(this.form));
        }
      } catch (e) {
        // ERROR HANDLER
      }
    },
    nextStep() {
      this.$router.push({ name: "legal-control-form-detail" });
    },
    saveData() {
      let url = `profile/user-control-member${
        this.$route.params.member_id ? "/" + this.$route.params.member_id : ""
      }`;
      const form = JSON.parse(JSON.stringify(this.form));
      this.form_dates.forEach(date => {
        form[date] = this.dateReFormat(form[date]);
      });
      form.user_control_id = this.$route.params.control_id;
      FhsAxios.post(url, form).then(res => {
        if (res.data.status) {
          this.$toasted.success("Данные сохранены");
          this.nextStep();
          return;
        }
        this.$toasted.error("Произошла ошибка");
        this.$emit("loading-status", false);
      });
    },
    handleFormSubmit() {
      if (!this.isFormChanged()) {
        this.nextStep();
      } else {
        this.saveData();
      }
    }
  },
  beforeMount() {
    this.fetchForm();
  }
};
</script>
